module.exports = __webpack_public_path__ + "assets/e82a761a1717941b7569ffa1076345b6.png";